// @flow
import React from 'react';
import { Disclaimer } from '@finect/tabular-components/Disclaimer';

// Frase común a todas las páginas de asesoramiento: la relación comercial con Finect.
const COMMERCIAL_AGREEMENT = 'Los asesores y entidades accesibles mantienen un acuerdo comercial con Finect.';

type Props = {
  note?: string
};

/**
 * Aviso legal sobre la relación comercial entre Finect y los asesores y entidades
 * que se muestran en las páginas de asesoramiento.
 *
 * @param note Matiz que añade la página concreta (p.ej. que el listado no constituye
 *             una recomendación personalizada)
 */
export const PartnersDisclaimer = ({ note }: Props) => (
  <Disclaimer text={note ? `${COMMERCIAL_AGREEMENT} ${note}` : COMMERCIAL_AGREEMENT} />
);
